module.exports = __webpack_public_path__ + "img/OverseaMember20.81efb18b.jpg";